import { parseEnum } from 'common/utils/enum.utils';
import { ErrorTypes } from './generated/api.enum';
import type { Components } from './generated/api';

/**
 * Default error when backend claims an error
 */
export class ApiError extends Error {
  public requestInfo: unknown;
  public responseInfo: unknown;
  public errorType: Components.Schemas.ErrorTypes;
  public readonly httpStatus?: number;

  constructor(
    apiResponse?: unknown,
    context: { requestInfo?: unknown; responseInfo?: unknown; httpStatus?: number } = {},
  ) {
    const value =
      apiResponse !== null && typeof apiResponse === 'object' && 'error' in apiResponse ? apiResponse.error : undefined;
    const errorType = parseEnum(ErrorTypes, value) ?? ErrorTypes.UNKNOWN;

    super(errorType);
    Object.setPrototypeOf(this, ApiError.prototype);

    this.requestInfo = context.requestInfo ?? {};
    this.responseInfo = context.responseInfo ?? {};
    this.httpStatus = context.httpStatus;
    this.errorType = errorType;
  }

  public getErrorType(): Components.Schemas.ErrorTypes {
    return this.errorType;
  }
}
